export default __webpack_public_path__ + "static/sterylnosc-8003b708f66fa9df8db783be6eb9a020.jpg";